module.exports = __webpack_public_path__ + "static/media/tarja-linhas-biodina.f3759318.jpg";